/**
 * Global configuration and utilities. The first resource to load.
 */
import Vue from 'vue'

// Global plugins
import '@/plugins/axios'

// Global directives
import '@/directives/analytics'
import { external } from '@/directives/external'

// Global components
import AddProviderLink from '@/components/common/AddProviderLink'
import ContentTag from '@/components/common/ContentTag'

// Define global components/directives
Vue.component('add-provider-link', AddProviderLink)
Vue.component('content-tag', ContentTag)
Vue.directive('external', external)



// WEBPACK FOOTER //
// ./frontend/src/globals.js